import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import StatsCards from './StatsCards';
import Header from './Header';
import DataTable from './DataTable';
import DestinationPopup from './DestinationPopup';
function Destination() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <>
            <div className="flex justify-center items-center h-screen sm:text-lg text-xs ">
                <h1 className="text-center sm:text-lg text-xs">
                    You can keep this page blank, and we will not have this function yet.
                    <span className="sm:text-lg text-xs font-bold block">
                        We will come back after the Kickstarter launch.
                    </span>
                </h1>
            </div>

        </>
        // <div className="min-h-screen bg-gray-100 md:p-8 p-4">
        //     <div className="mx-auto space-y-8">
        //         <div className="grid md:grid-cols-2 gap-4 w-full">
        //             <div className="w-full">
        //                 <Header />
        //             </div>
        //             <div className=" w-full "> 
        //                 <StatsCards />
        //             </div>
        //         </div>

        //         {/* Table Section */}
        //         <div className="bg-white rounded-[1.75rem] shadow-md p-6">
        //             <div className="flex justify-between items-center mb-4">
        //                 <h2 className="font-roboto-mono text-[24px] font-bold">
        //                     Cities per Country
        //                 </h2>
        //                 <button
        //                     onClick={() => setIsPopupOpen(true)}
        //                     className="flex items-center gap-2 text-black hover:text-gray"
        //                 >
        //                     <Plus size={20} />
        //                     <span>Add</span>
        //                 </button>
        //             </div>
        //             <div className="w-full overflow-auto whitespace-nowrap">
        //                 <DataTable />
        //             </div>
        //         </div>
        //     </div>

        //     <DestinationPopup
        //         isOpen={isPopupOpen}
        //         onClose={() => setIsPopupOpen(false)}
        //     />
        // </div>
    );
}

export default Destination;